import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    color,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    mb,
    ml,
    onDesktop,
    p,
    w100
} from "@pg-design/helpers-css";
import {ArrowIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

export interface IHeaderData {
    count?: number;
    price?: number;
    percent?: number | null;
}

interface IProps {
    data: IHeaderData;
    type: HeaderBoxType;
}

export enum HeaderBoxType {
    FLATS_COUNT,
    PRICE,
    PRICE_M2
}

export const HeaderBox = (props: IProps) => {
    let boxText;

    switch (props.type) {
        case HeaderBoxType.FLATS_COUNT:
            boxText = "Liczba mieszkań";
            break;
        case HeaderBoxType.PRICE:
            boxText = "Średnia cena ofertowa";
            break;
        case HeaderBoxType.PRICE_M2:
            boxText = (
                <>
                    Średnia cena za m<sup>2</sup>
                </>
            );

            break;
        default:
            boxText = "Liczba nieruchomości";
    }

    const percent = !!props.data && props.data.percent;

    return (
        <div css={infoBox}>
            <div>
                <Text variant="headline_2" as="p" css={mb(0.5)}>
                    {props.data?.price && priceFormat(props.data.price)}
                    {props.data?.count && props.data.count}
                </Text>
                <Text variant="body_copy_2">{boxText}</Text>
            </div>
            <div css={smallBox}>
                <div>
                    <Text variant="body_copy_2" strong align="center" css={flexAbsoluteCenter}>
                        {percent && percent > 0 ? `+${percent}%` : `${percent}%`}
                        {percent && percent !== 0 ? (
                            <Arrow size="2" fill="#fff" css={ml(1)} rotate={percent > 0 ? `90deg` : `-90deg`} />
                        ) : (
                            <span css={lineStyle} />
                        )}
                    </Text>
                </div>
                <Text variant="info_txt_3">Rok do roku</Text>
            </div>
        </div>
    );
};

const infoBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.primary)};
    ${p(3)};
    ${borderRadius(2)};
    ${flex("center", "space-between")};
    gap: ${calculateRemSize(2)};
    ${w100};
    max-width: 360px;

    ${onDesktop(css`
        ${flexAbsoluteCenter};
        max-width: 25%;

        @media (max-width: ${theme.breakpoints.lg}) {
            max-width: 33%;
        }
    `)};
`;

const smallBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.secondary)};
    ${color("#fff")};
    ${p(1)};
    ${borderRadius(1)};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(1)};
`;

const Arrow = styled(ArrowIcon)<{rotate: string}>`
    transform: scale(${(props) => props.size}) rotate(${(props) => props.rotate});
`;

const lineStyle = css`
    display: inline-block;
    width: ${calculateRemSize(1)};
    height: 1px;
    ${ml(1)};
    border: 1px solid white;
`;
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    color,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    mb,
    ml,
    onDesktop,
    p,
    w100
} from "@pg-design/helpers-css";
import {ArrowIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

export interface IHeaderData {
    count?: number;
    price?: number;
    percent?: number | null;
}

interface IProps {
    data: IHeaderData;
    type: HeaderBoxType;
}

export enum HeaderBoxType {
    FLATS_COUNT,
    PRICE,
    PRICE_M2
}

export const HeaderBox = (props: IProps) => {
    let boxText;

    switch (props.type) {
        case HeaderBoxType.FLATS_COUNT:
            boxText = "Liczba mieszkań";
            break;
        case HeaderBoxType.PRICE:
            boxText = "Średnia cena ofertowa";
            break;
        case HeaderBoxType.PRICE_M2:
            boxText = (
                <>
                    Średnia cena za m<sup>2</sup>
                </>
            );

            break;
        default:
            boxText = "Liczba nieruchomości";
    }

    const percent = !!props.data && props.data.percent;

    return (
        <div css={infoBox}>
            <div>
                <Text variant="headline_2" as="p" css={mb(0.5)}>
                    {props.data?.price && priceFormat(props.data.price)}
                    {props.data?.count && props.data.count}
                </Text>
                <Text variant="body_copy_2">{boxText}</Text>
            </div>
            <div css={smallBox}>
                <div>
                    <Text variant="body_copy_2" strong align="center" css={flexAbsoluteCenter}>
                        {percent && percent > 0 ? `+${percent}%` : `${percent}%`}
                        {percent && percent !== 0 ? (
                            <Arrow size="2" fill="#fff" css={ml(1)} rotate={percent > 0 ? `90deg` : `-90deg`} />
                        ) : (
                            <span css={lineStyle} />
                        )}
                    </Text>
                </div>
                <Text variant="info_txt_3">Rok do roku</Text>
            </div>
        </div>
    );
};

const infoBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.primary)};
    ${p(3)};
    ${borderRadius(2)};
    ${flex("center", "space-between")};
    gap: ${calculateRemSize(2)};
    ${w100};
    max-width: 360px;

    ${onDesktop(css`
        ${flexAbsoluteCenter};
        max-width: 25%;

        @media (max-width: ${theme.breakpoints.lg}) {
            max-width: 33%;
        }
    `)};
`;

const smallBox = (theme: Theme) => css`
    ${backgroundColor(theme.colors.secondary)};
    ${color("#fff")};
    ${p(1)};
    ${borderRadius(1)};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(1)};
`;

const Arrow = styled(ArrowIcon)<{rotate: string}>`
    transform: scale(${(props) => props.size}) rotate(${(props) => props.rotate});
`;

const lineStyle = css`
    display: inline-block;
    width: ${calculateRemSize(1)};
    height: 1px;
    ${ml(1)};
    border: 1px solid white;
`;
